<template>
  <h1>Setting Up IMPROVE</h1>
</template>
<script>
export default {
  name: "SettingUpWidget",
  data() {
    return {};
  }
};
</script>
